import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirebaseConfig } from './lib/firebaseConfig.ts';
import { env } from './lib/env.ts';
import { BuildEnvironment, getBuildEnvironment } from './lib/buildEnvironment.ts';

const app = initializeApp(getFirebaseConfig());
export const auth = getAuth(app);

if (getBuildEnvironment() === BuildEnvironment.E2E && env.firebaseAuthEmulatorUrl) {
    connectAuthEmulator(auth, env.firebaseAuthEmulatorUrl, { disableWarnings: true });
}
